export default "__VITE_ASSET__CzTEGRiq__"